import { EmptyState, Loader, Panel } from "@coaching-culture/ui";
import CenterColumn from "components/CenterColumn";
import { PageHeader } from "components/PageHeader";
import { minBy, sortBy, uniqBy } from "lodash";
import ContentList from "pages/Mindset/ModuleList";
import { useAvailableContent } from "queries/mindset";
import { FaBookOpen } from "react-icons/fa";
import { Redirect, useParams } from "react-router-dom";

const LessonsList = () => {
  const { category } = useParams<{ category?: string }>();
  const { data: content, isFetched } = useAvailableContent();

  if (!isFetched) {
    return <Loader />;
  }

  const lessons = content.filter((x) => x.type === "lesson");

  if (lessons.length === 0) {
    return (
      <>
        <CenterColumn>
          <PageHeader
            text={"Lessons"}
            subtitle="Giving everybody the capability to coach"
          />
          <Panel>
            <EmptyState icon={FaBookOpen} title="No lessons yet">
              Lessons will appear here once they're made available to you.
            </EmptyState>
          </Panel>
        </CenterColumn>
      </>
    );
  }

  const cats = uniqBy(
    lessons.map((x) => x.category),
    "id",
  );
  const cat = cats.find((x) => x.id === category);

  if (category == null || cat == null) {
    return (
      <Redirect
        to={`/solutions/lessons/${minBy(cats, (x) => x.orderIndex).id}`}
      />
    );
  }

  const sortedLessons = sortBy(
    content.filter((x) => x.category.id === category),
    "orderIndex",
  );

  if (sortedLessons.length === 0) {
    return (
      <Panel>
        <EmptyState icon={FaBookOpen} title="No lessons yet">
          Lessons in this category will appear here once they're made available
          to you.
        </EmptyState>
      </Panel>
    );
  }

  return (
    <>
      <CenterColumn>
        <PageHeader
          text={cat.name}
          subtitle="Giving everybody the capability to coach"
        />
        <ContentList items={sortedLessons} />
      </CenterColumn>
    </>
  );
};

export default LessonsList;
